// The Field Officer assessment's nursery fields, as shown on the booking detail.

// AMS-83: newer assessments carry a choice; older ones a distance in km.
export const NURSERY_DISTANCE_LABELS = {
  CLOSE_BY: "Close by",
  TRANSPORT_REQUIRED: "Transportation Required",
};

// Today's date in the browser's timezone, as YYYY-MM-DD.
export const todayIsoDate = (now = new Date()) =>
  new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

// AMS-82: newer assessments carry the nursery's sowing date; older ones only an age in days.
export const formatNurseryAge = (assessment, now = new Date()) => {
  if (assessment?.nurseryDate) {
    const sown = String(assessment.nurseryDate).slice(0, 10);
    const [year, month, day] = sown.split("-");
    const days = Math.round((Date.parse(todayIsoDate(now)) - Date.parse(sown)) / 86400000);
    return `${day}-${month}-${year} (${days} days)`;
  }
  const age = assessment?.nurseryAgeInDays;
  return age !== undefined && age !== null ? `${age} days` : "-";
};

export const formatNurseryDistance = (assessment) => {
  if (assessment?.nurseryDistance) {
    return NURSERY_DISTANCE_LABELS[assessment.nurseryDistance] || assessment.nurseryDistance;
  }
  const km = assessment?.nurseryDistanceToFieldInKm;
  return km !== undefined && km !== null ? `${km} km` : "-";
};
